import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `GrupoVerraco/imprimirGrupoVerraco`, method: 'POST', body: list, token: token})
}
